import React from "react";
import "./Support.css";
import supportImage from "../assets/support1.png"; // Importing the image you specified

const Support = () => {
  return (
    <div className="support-page-wrapper">
      <h2 className="support-main-title">SUPPORT</h2>
      
      <div className="support-content-container">
        {/* Left Side: Text & Form */}
        <div className="support-form-section">
          <p className="support-intro-text">
            Need help? Shoot us an email at{" "}
            <a href="mailto:support@quickfit.com" className="support-email-link">
              support@quickfit.com
            </a>{" "}
            or fill out the form below and we’ll get back to you within{" "}
            <strong>24 hours</strong>
          </p>

          <form
            className="support-form"
            onSubmit={(e) => {
              e.preventDefault();
              // Handle submit logic here
            }}
          >
            <div className="form-group">
              <input
                type="text"
                name="name"
                placeholder="NAME"
                className="support-input"
                required
              />
            </div>
            <div className="form-group">
              <input
                type="email"
                name="email"
                placeholder="EMAIL"
                className="support-input"
                required
              />
            </div>
            <div className="form-group">
              <textarea
                name="message"
                placeholder="HOW CAN WE HELP?"
                className="support-textarea"
                required
              />
            </div>
            <button type="submit" className="support-submit-btn">
              SEND MESSAGE
            </button>
          </form>
        </div>

        {/* Right Side: Image */}
        <div className="support-image-section">
          <img src={supportImage} alt="Support" className="support-hero-img" />
        </div>
      </div>
    </div>
  );
};

export default Support;